export const RoutesRedirect = [
  {
    from: '/',
    to: '/home'
  }
];
